import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { push } from "connected-react-router";
import {
  Container,
  Paragraph,
  Button,
  CloseButton,
  Icon,
  ModalTitle
} from "./Styles";
import ModalActions from "../../redux/reducers/modal.reducer";

const UserNotExistsModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const redirectToRecovery = () => {
    dispatch(ModalActions.setConditionalModalState(false));
    dispatch(push("/account-recovery"));
  };

  return (
    <Container>
      <CloseButton id="close-button" onClick={redirectToRecovery}>
        <Icon alt="previous" src="/assets/images/close_2.png" />
      </CloseButton>
      <ModalTitle>{t("accountRecovery.userNotExistsTitle")}</ModalTitle>
      <Paragraph>{`${t("accountRecovery.userNotExistsText")}`}</Paragraph>
      <Button id="continue-button" onClick={redirectToRecovery}>
        {t("accountRecovery.continueButton")}
      </Button>
    </Container>
  );
};

export default UserNotExistsModal;
